<script setup>
import FooterLayout from '@/layouts/FooterLayout.vue';
import MenuLeftLayout from '@/layouts/MenuLeftLayout.vue';
import MenuTopLayout from '@/layouts/MenuTopLayout.vue';
import { user } from '@/modules/configuracoes/funcionario/store';
import LoadingApp from '@/components/utilApp/LoadingApp.vue';
import { inject, onBeforeMount, ref, provide } from 'vue';
import { useMenuState } from '@/composables/useMenuState.js';
import { useRouter } from 'vue-router';
import { props as filialPadrao, fillFilial } from '@/modules/configuracoes/filial/store';
import { setCaixa, FinanceiroCaixaMovService, props as propsCaixaAberto } from '@/modules/financeiro/financeiroCaixaMov/store/index';
import MessageApp from '@/components/utilApp/MessageApp.vue';
import { setSession, SessionService } from '@/modules/session/store/index';
import { common, guidUtil } from '@/utils';
import { KeysService, serialPrincipal, diasLiberacao, liberarMaisTarde, sistemaLiberadoDias } from '@/modules/configuracoes/keys/store/';
import { LiberacaoMessageEnumerator, Tela, TipoEnum } from '@/enums/configuracao';
import { valPermissaoNegativaBooleanCommon } from '@/modules/configuracoes/permissionValidator/store';

const $cookies = inject('$cookies');
const router = useRouter();
const loadingApp = ref();
provide('loadingApp', loadingApp);
const { isMenuOpen, hideMenu } = useMenuState();
const filial = $cookies.get('Filial');
const statusMessage = ref();
const liberarMaisTardeCookies = $cookies.get('liberarMaisTarde');
const sistemaLiberadoDiasCookies = $cookies.get('sistemaLiberadoDias');

async function getSession() {
  const publicToken = $cookies.get('PublicToken');

  if (publicToken) {
    await SessionService.get(filial)
      .then(((data) => {
        setSession(data);
      }));
  } else {
    window.location.href = 'https://auth.vr.app.br/';
  }
}

async function verifyFilial() {
  if (!filial) {
    router.push('/filial/selecionar/');
  } else if (!filialPadrao) {
    fillFilial(filial);
  }
}

async function verifyCaixaAberto() {
  if (propsCaixaAberto.value.ide === guidUtil.empty) {
    const inputModel = {
      filial__Codigo: filialPadrao.value.filial.codigo,
      aberturaUsuario__Ide: user.value.ide,
    };

    if (inputModel.filial__Codigo > 0 && propsCaixaAberto.value.ide === guidUtil.empty) {
      await FinanceiroCaixaMovService.verifyCaixaAberto(inputModel)
        .then((data) => {
          setCaixa(data);
        })
        .catch((error) => {
          statusMessage.value?.setMessageBody(error);
        });
    }
  }
}

async function verificandoAvisoEPermissao() {
  await valPermissaoNegativaBooleanCommon(Tela.NaoExibirAvisoVencimento.valueEnum, TipoEnum.Permitir.valueEnum)
    .then((data) => {
      if (data || (diasLiberacao.value < 0)) {
        router.push({ name: 'liberacaoAviso' });
      }
    });
}

async function checandoLiberacao() {
  const inputModel = {
    serial: serialPrincipal.value,
    filial__Codigo: filialPadrao.value.filial.codigo,
  };
  await KeysService.chegandoLiberacaoDias(inputModel)
    .then((data) => {
      diasLiberacao.value = data;
      if (sistemaLiberadoDiasCookies) {
        sistemaLiberadoDias.value = sistemaLiberadoDiasCookies;
        common.setCookie('sistemaLiberadoDias', null, '0s');
      }
      if (liberarMaisTardeCookies) {
        liberarMaisTarde.value = true;
        common.setCookie('liberarMaisTarde', null, '0s');
      } else if (diasLiberacao.value <= LiberacaoMessageEnumerator.DiasParaFecharTelaAposSolicitarPagamento.valueEnum && !liberarMaisTarde.value) {
        verificandoAvisoEPermissao();
      }
    }).catch((error) => {
      statusMessage.value.setMessageBody(error);
    });
}

async function validKeys() {
  await KeysService.validSerial(filialPadrao.value.filial.codigo)
    .then((data) => {
      serialPrincipal.value = data;
      checandoLiberacao();
    })
    .catch(() => {
      router.push({ name: 'serial' });
    });
}

onBeforeMount(async () => {
  await Promise.all([await getSession(), await verifyFilial()])
    .then(() => {
      if (filialPadrao.value.filial.codigo > 0) {
        validKeys();
        verifyCaixaAberto();
      }
    });
});
</script>

<template>
  <div class="emptyLayout">
    <LoadingApp ref="loadingApp" />
    <MenuTopLayout :is="MenuTopLayout" />
    <MenuLeftLayout :is="MenuLeftLayout" />
    <div v-if="isMenuOpen" class="sidenav-overlay show" @click="hideMenu()"></div>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper container-xxl p-0">
        <div class="content-body">
          <div class="row">
            <div class="col-12">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterLayout :is="FooterLayout" />
  </div>
  <MessageApp ref="statusMessage" @hideAlert="statusMessage.hideMessage()" showClose :positionFixe="true" />
</template>
